import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "window-manager",
  "aria-live": "polite"
}
const _hoisted_2 = {
  key: 0,
  class: "content-window-taskbar"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleWindows, (entry) => {
        return (_openBlock(), _createBlock($setup["ContentWindow"], {
          key: entry.id,
          "window-state": entry,
          labels: $props.labels,
          onClose: $event => ($setup.closeWindow(entry.id)),
          onMinimize: $event => ($setup.minimizeWindow(entry.id)),
          onToggleMaximize: $event => ($setup.toggleMaximizeWindow(entry.id)),
          onFocus: $event => ($setup.focusWindow(entry.id)),
          onUpdateGeometry: $event => ($setup.updateGeometry(entry.id, $event))
        }, null, 8 /* PROPS */, ["window-state", "labels", "onClose", "onMinimize", "onToggleMaximize", "onFocus", "onUpdateGeometry"]))
      }), 128 /* KEYED_FRAGMENT */)),
      ($setup.minimizedWindows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.minimizedWindows, (entry) => {
              return (_openBlock(), _createElementBlock("button", {
                key: `taskbar-${entry.id}`,
                type: "button",
                class: "content-window-taskbar-btn",
                onClick: $event => ($setup.restoreWindow(entry.id))
              }, _toDisplayString(entry.title), 9 /* TEXT, PROPS */, _hoisted_3))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}